export const UPGRADE_CARD_MIN_VALUE = 1;
export const UPGRADE_CARD_MAX_VALUE = 200;
export const UPGRADE_CARD_STEP = 1;
